import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { CommonFeatureEntryInterface } from 'src/app/model/commonFeature/common-feature-entry-interface';
import { CommonFeatureInterface } from 'src/app/model/commonFeature/common-feature-interface';
import { ProductCommonFeatureInterface } from 'src/app/model/commonFeature/product-common-feature-interface';
import { CommonFeatureService } from 'src/app/services/common-feature-service/common-feature.service';

interface SelectedFeatureGroup {
  featureId: number;
  featureName: string;
  entries: CommonFeatureEntryInterface[];
  expanded: boolean;
}

@Component({
    selector: 'app-common-feature-product-creation',
    templateUrl: './common-feature-product-creation.component.html',
    styleUrls: ['./common-feature-product-creation.component.css'],
    standalone: false
})
export class CommonFeatureProductCreationComponent implements OnInit, OnChanges {

  public allCommonFeatures: CommonFeatureInterface[] = [];
  public availableCommonFeatures: CommonFeatureInterface[] = [];
  public selectedCommonFeatures: ProductCommonFeatureInterface[] = [];
  public shownSelectedFeatures: ProductCommonFeatureInterface[] = []; // not in use anymore
  availableFeatureSearch: string = '';
  selectedFeatureSearch: string = ''; // not in use anymore
  @Input() selected: ProductCommonFeatureInterface[] = [];
  private _selectedCategory: any | null = null;
  @Output() selectedChange = new EventEmitter<ProductCommonFeatureInterface[]>();
  @Input()
  set selectedCategory(category: any | null) {
    this._selectedCategory = category;
    this.updateAvailableCommonFeature();
    this.updateSelectedFeaturesAfterCategoryChange();
  }
  get selectedCategory(): any | null {
    return this._selectedCategory;
  }

  public groupedSelectedFeaturesArray: SelectedFeatureGroup[] = [];

  constructor(

    private commonFeatureService: CommonFeatureService
  ) {

  }

  ngOnInit(): void {
    this.commonFeatureService
      .getAllFeatures()
      .subscribe((success: CommonFeatureInterface[]) => {
        this.allCommonFeatures = success;
        this.updateAvailableCommonFeature();
        this.updateSelectedFeaturesAfterCategoryChange();
        // this.updateShownSelectedCommonFeatures();
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selected'] && changes['selected'].currentValue) {
      this.selectedCommonFeatures = [...changes['selected'].currentValue];
      this.updateGroupedSelectedFeatures();
      // this.updateShownSelectedCommonFeatures();
    }
  }

  // this method is not in use
  /* Selects the Entry of an Feature */
  public selectFeatureEntry(
    feature: CommonFeatureInterface,
    entry: CommonFeatureEntryInterface
  ): void {
    this.selectedCommonFeatures.push({
      feature: feature,
      entry: entry
    });
    // this.updateShownSelectedCommonFeatures();
    this.emitSelection();
  }


  /* Clears the SearchText for available Features */
  public clearSearchText(): void {
    this.availableFeatureSearch = '';
    this.updateAvailableCommonFeature();
  }

  /* Clears the SearchText for selected Features */
  public clearSearchTextSelected(): void {
    this.selectedFeatureSearch = '';
    // this.updateShownSelectedCommonFeatures();
  }

  /* Removes Feature from the Selected Feature List */
  public removeSelectedFeature(index: number): void {
    this.selectedCommonFeatures.splice(index, 1);
    // this.updateShownSelectedCommonFeatures();
    this.emitSelection();
  }


  /**
   * Removes all already selected feature Entries from the given list of featureEntries.
   * Used to remove already selected entries in the "available" colmn expanded Features.
   *
   * @param featureEntries
   */
  removeSelectedEntriesFrom(featureEntries: CommonFeatureEntryInterface[]) {
    let selectedFeatureEntries = this.selectedCommonFeatures.map(
      (x) => x.entry
    );
    return featureEntries.filter((featureEntry) => {
      return (
        selectedFeatureEntries.findIndex(
          (x) => featureEntry.id == x.id
        ) < 0
      );
    });
  }

  public updateAvailableCommonFeature(): void {
    this.availableCommonFeatures = [];

    const selectedValue = this.selectedCategory ?? null;

    this.allCommonFeatures.forEach((feature) => {
      // Optional defensive: ensure feature.categories is an array
      const featureCategories: string[] = Array.isArray((feature as any).categories)
        ? (feature as any).categories
        : [];

      const matchesCategory =
        selectedValue === null
          ? false // or true if you want to show all when no category chosen
          : featureCategories.includes(selectedValue);

      const matchesSearch =
        this.doesTextIncludeSearchText(feature.name, this.availableFeatureSearch) ||
        feature.featureEntries.some((entry) =>
          this.doesTextIncludeSearchText(entry.name, this.availableFeatureSearch)
        );

      if (matchesCategory && matchesSearch) {
        this.availableCommonFeatures.push(feature);
      }
    });
  }

  private emitSelection(): void {
    this.selectedChange.emit([...this.selectedCommonFeatures]);
  }

  // This methode is not in use
  public updateShownSelectedCommonFeatures(): void {
    this.shownSelectedFeatures = [];

    this.selectedCommonFeatures.forEach((selected) => {
      if (
        this.doesTextIncludeSearchText(
          selected.feature.name,
          this.selectedFeatureSearch
        ) ||
        this.doesTextIncludeSearchText(
          selected.entry.name,
          this.selectedFeatureSearch
        )
      ) {
        this.shownSelectedFeatures.push(selected);
      }
    });
  }

  private doesTextIncludeSearchText(
    text: string,
    searchText: string
  ): boolean {
    if (!text) return false;
    if (!searchText) return true;
    return text.toLowerCase().includes(searchText.toLowerCase());
  }

  public isEntrySelected(
    feature: CommonFeatureInterface,
    entry: CommonFeatureEntryInterface
  ): boolean {
    return this.selectedCommonFeatures.some(
      (x) => x.feature.id === feature.id && x.entry.id === entry.id
    );
  }

  public onEntryToggle(
    feature: CommonFeatureInterface,
    entry: CommonFeatureEntryInterface,
    checked: boolean
  ): void {
    if (checked) {
      this.selectedCommonFeatures.push({ feature, entry });
    } else {
      this.selectedCommonFeatures = this.selectedCommonFeatures.filter(
        x => !(x.feature.id === feature.id && x.entry.id === entry.id)
      );
    }

    this.updateGroupedSelectedFeatures();
    this.emitSelection();
  }

  public removeSelectedFeatureByFeatureAndEntry(featureId: number, entryId: number): void {
    this.selectedCommonFeatures = this.selectedCommonFeatures.filter(
      x => !(x.feature.id === featureId && x.entry.id === entryId)
    );

    this.updateGroupedSelectedFeatures();
    this.emitSelection();
  }

  private updateGroupedSelectedFeatures(): void {
    const groups: SelectedFeatureGroup[] = [];
    this.selectedCommonFeatures.forEach(selected => {
      let group = groups.find(g => g.featureId === selected.feature.id);
      if (group) {
        group.entries.push(selected.entry);
        group.expanded = true;
      } else {
        groups.push({
          featureId: selected.feature.id,
          featureName: selected.feature.name,
          entries: [selected.entry],
          expanded: true
        });
      }
    });

    this.groupedSelectedFeaturesArray.forEach(oldGroup => {
      const newGroup = groups.find(g => g.featureId === oldGroup.featureId);
      if (newGroup) {
        if (newGroup.entries.length > oldGroup.entries.length) {
          newGroup.expanded = true; 
        } else {
          newGroup.expanded = oldGroup.expanded;
        }
      }
    });

    this.groupedSelectedFeaturesArray = groups;
  }

  private updateSelectedFeaturesAfterCategoryChange(): void {
    if (!this.allCommonFeatures || this.allCommonFeatures.length === 0) return;
    const validFeatureIds = this.availableCommonFeatures.map(f => f.id);

    this.selectedCommonFeatures = this.selectedCommonFeatures.filter(
      sel => validFeatureIds.includes(sel.feature.id)
    );

    this.updateGroupedSelectedFeatures();
    this.emitSelection();
  }

  public hasAllRequiredSelections(): boolean {
    const optionalFeatures = ['KI', 'Datenformate', 'BIM-Anwendungsfälle'];
    return this.availableCommonFeatures
      .filter(feature => !optionalFeatures.includes(feature.name))
      .every(feature =>
        this.selectedCommonFeatures.some(sel => sel.feature.id === feature.id)
      );
  }

  // TO DO: This logic is just temporary until we have a proper way to define required/optional features
  public isFeatureRequired(feature: CommonFeatureInterface): boolean {
    const optionalFeatures = ['KI', 'Datenformate', 'BIM-Anwendungsfälle'];
    return !optionalFeatures.includes(feature.name);
  }
}
